import React from "react";
import { Box, Skeleton } from "@mui/material";

const bubbleSx = { borderRadius: 2 };

const TicketChatSkeleton = () => (
  <Box
    display="flex"
    flexDirection="column"
    gap={1.5}
    aria-busy="true"
    aria-label="Caricamento messaggi chat"
  >
    <Box display="flex" justifyContent="flex-end">
      <Skeleton variant="rounded" sx={bubbleSx} width="68%" height={80} />
    </Box>
    <Box display="flex" justifyContent="flex-start">
      <Skeleton variant="rounded" sx={bubbleSx} width="45%" height={52} />
    </Box>
    <Box display="flex" justifyContent="flex-end">
      <Skeleton variant="rounded" sx={bubbleSx} width="55%" height={64} />
    </Box>
  </Box>
);

export default TicketChatSkeleton;
